import { useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { TableRow, TableCell, MenuItem, Avatar, Box, Stack, Typography } from '@mui/material';
// components

import useLocales from 'src/hooks/useLocales';

import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import Iconify from 'src/components/Iconify';
import { TableMoreMenu } from 'src/components/table';
import { IContractInfo } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';
import { DateConverter } from 'src/sections/common/DateConverter';
import Label from 'src/components/Label';
import { GetCurrencySymbol } from 'src/sections/common/GetCurrencySymbol';
import { baseUrl } from 'src/api/baseUrl';
// ----------------------------------------------------------------------

type Props = {
  row: IContractInfo;
  // selected: boolean;
  onEditRow: VoidFunction;
  //onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  handleDetail: VoidFunction;
  handleApproveDiscount: VoidFunction;
  handleExtend: VoidFunction;
  handleAttachment: VoidFunction;
  handleRecievedAdvanceApproval: VoidFunction;
  handleApprovedAndLockContract: VoidFunction;
  handleContractTerminate: VoidFunction;
  handleRentAdvancPayment: VoidFunction;
  handleDocumentView: VoidFunction;
  handleDiscountDocumentView: VoidFunction;
  index: any;
};

export default function ContractInfoTableRow({
  row,
  onEditRow,
  handleDetail,
  handleAttachment,
  handleApproveDiscount,
  handleRecievedAdvanceApproval,
  handleApprovedAndLockContract,
  handleContractTerminate,
  handleRentAdvancPayment,
  handleDocumentView,
  handleDiscountDocumentView,
  onDeleteRow,
  handleExtend,
  index,
}: Props) {
  const theme = useTheme();

  const {
    contractNumber,
    customerName,
    shopCode,
    contractStatus,
    contractEndDate,
    contractStartDate,
    contractDuration,
    finalRentPerMonth,
    customerPhotoPath,
    advancePayment
  } = row;
  const { translate } = useLocales();
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };


  const getUserDataFromLocalStorage: any = localStorage.getItem('userData');

  const changeLocalStorgeStringToValue = JSON.parse(getUserDataFromLocalStorage);

  const is_super_admin = changeLocalStorgeStringToValue.IsSuperAdmin;
  let Url = baseUrl;
  return (
    <TableRow hover>
      <TableCell align="left">{index + 1}</TableCell>
      <TableCell align="left">{contractNumber}</TableCell>

      <TableCell align="left">
        <Stack direction="row" alignItems="center">
          <Avatar
            alt={customerName}
            src={Url + customerPhotoPath}
            sx={{ width: 60, height: 60 }} // Increase size here
          />
          <Box sx={{ ml: 2 }}>
            <Typography variant="subtitle2">{customerName}</Typography>
          </Box>
        </Stack>
      </TableCell>

      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {shopCode}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize', alignItems: 'center' }}>
        {<DateConverter date={contractStartDate} />}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize', alignItems: 'center' }}>
        {<DateConverter date={contractEndDate} />}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize', alignItems: 'center' }}>
        {contractDuration}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize', alignItems: 'center' }}>
        {advancePayment}{' '}
        {row.rentCarrencyId === 2 ? GetCurrencySymbol('afn') : GetCurrencySymbol('dollar')}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize', alignItems: 'center' }}>
        {finalRentPerMonth}{' '}
        {row.rentCarrencyId === 2 ? GetCurrencySymbol('afn') : GetCurrencySymbol('dollar')}
      </TableCell>

      <TableCell align="left" sx={{ textTransform: 'capitalize', alignItems: 'center' }}>
        <Label
          color={
            row.contractStatusId === 2 || row.contractStatusId === 3
              ? 'info'
              : row.contractStatusId === 5
                ? 'error'
                : row.contractStatusId === 6
                  ? 'warning'
                  : row.contractStatusId === 4
                    ? 'success'
                    : row.contractStatusId === 10
                      ? 'success'
                      : 'default'
          }
        >
          {' '}
          {contractStatus}
        </Label>
      </TableCell>

      <TableCell align="left">
        <TableMoreMenu
          open={openMenu}
          onOpen={handleOpenMenu}
          onClose={handleCloseMenu}
          width={230}
          actions={
            <>
              {is_super_admin && (
                <PermissionBasedGuard permissions={['Contract-Delete']}>
                  <MenuItem
                    onClick={() => {
                      onDeleteRow();
                      handleCloseMenu();
                    }}
                    // style={{ display: row.isLocked === true ? 'none' : '' }}
                    sx={{ color: 'error.main' }}
                  >
                    <Iconify icon={'eva:trash-2-outline'} />
                    {translate('CRUD.Delete')}
                  </MenuItem>
                </PermissionBasedGuard>
              )}

              <PermissionBasedGuard permissions={['Contract-GetDetail']}>
                <MenuItem
                  onClick={() => {
                    handleDetail();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('Employee.Details')}
                </MenuItem>
              </PermissionBasedGuard>




              <PermissionBasedGuard permissions={['Contract-Terminate']}>
                <MenuItem
                  onClick={() => {
                    handleContractTerminate();
                    handleCloseMenu();
                  }}
                  style={{
                    display:
                      row.isLocked && !row.isTerminated && !row.isContractExpired ? '' : 'none',
                  }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('contractsInfo.ContractTerminate')}
                </MenuItem>
              </PermissionBasedGuard>




              <PermissionBasedGuard permissions={['Contract-addAttachment']}>
                <MenuItem
                  onClick={() => {
                    handleAttachment();
                    handleCloseMenu();
                  }}
                  style={{ display: row.isLocked === true ? '' : 'none' }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('contractsInfo.AddAttachment')}
                </MenuItem>
              </PermissionBasedGuard>
              <PermissionBasedGuard permissions={['TermsAndCondition-GetList']}>
                <MenuItem
                  onClick={() => {
                    handleDiscountDocumentView();
                    handleCloseMenu();
                  }}
                  style={{
                    display: row.discountStartDate &&
                      row.discountEndDate &&
                      new Date(row.discountEndDate).getTime() - new Date(row.discountStartDate).getTime() > 24 * 60 * 60 * 1000
                      ? ''
                      : 'none'
                  }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('contractsInfo.dicountDoc')}
                </MenuItem>
              </PermissionBasedGuard>
              <PermissionBasedGuard permissions={['TermsAndCondition-GetList']}>
                <MenuItem
                  onClick={() => {
                    handleDocumentView();
                    handleCloseMenu();
                  }}
                  style={{ display: row.isLocked === true ? '' : 'none' }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('contractsInfo.documentView')}
                </MenuItem>
              </PermissionBasedGuard>

              <PermissionBasedGuard permissions={['RentPayment-Create']}>
                <MenuItem
                  onClick={() => {
                    handleRentAdvancPayment();
                    handleCloseMenu();
                  }}
                  style={{
                    display:
                      row.isLocked === true && !row.isTerminated && !row.isContractExpired
                        ? ''
                        : 'none',
                  }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('contractsInfo.RentAdvancePayment')}
                </MenuItem>
              </PermissionBasedGuard>
            </>
          }
        />
      </TableCell>
    </TableRow>
  );
}
